export enum SanitationEnum {
  ALTO = "ALTO",
  BAIXO = "BAIXO",
  MEDIO = "MEDIO",
  NENHUM = "NENHUM",
}
